/**
 * 겹침 순서를 한 곳에서 정한다.
 *
 * 머리글은 sticky 에 backdrop-blur 가 걸려 있어 합성 레이어를 만든다.
 * 같은 z-index 의 오버레이가 그 위를 덮으면 브라우저가 배경을 다시
 * 샘플링하면서 열 때 한 번 깜빡이고, 닫을 때 지워진 레이어의 잔상이
 * 한 번 비친다. 층을 숫자로 갈라 두면 그 다툼이 없다.
 */

export const Z_HEADER = 50
export const Z_OVERLAY = 60
export const Z_TOAST = 70

/** Tailwind 클래스로 쓰는 값 (임의값 문법) */
export const Z_CLASS = {
  header: 'z-50',
  overlay: 'z-[60]',
  toast: 'z-[70]',
} as const

export default { Z_HEADER, Z_OVERLAY, Z_TOAST, Z_CLASS }
